var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-dialer-keypad",
      class: ((_obj = {}), (_obj["is-" + _vm.size] = true), _obj),
    },
    [
      _c("input", {
        staticClass: "keypad-input",
        attrs: { disabled: "" },
        domProps: { value: _vm.dial },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "keypad-keys" },
        _vm._l(_vm.KEYS, function (key) {
          return _c("base-icon-button", {
            key: key,
            attrs: {
              content: key,
              "is-disabled": _vm.isDisabled,
              size: _vm.size,
              color: "primary",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("key-click", key)
              },
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }